/**
 * Runtime helpers for application constants compiled from lib/core/Constants.cfc.
 * Expects __GlobalConstantsObject.js to have defined CONSTANTS and CONST_GROUPS.
 *
 * @param key {String} - constant name (e.g. 'USERACCESS_ADMIN')
 * @return {*} - constant value
 */
function getConstant(key) {
  if (typeof CONSTANTS === 'undefined' || typeof CONSTANTS[key] === 'undefined') {
    if (typeof Bugsnag !== 'undefined' && Bugsnag.notify) {
      Bugsnag.notify('JS constant missing: ' + key);
    }
    throw new Error('Unknown constant: ' + key);
  }
  return CONSTANTS[key];
}

/**
 * Compare a runtime value to a named constant (loose ==, matching CF).
 *
 * Pass API/DOM **codes** (string or number), e.g. approved "2", category "SCHEDULE".
 * Strings are trimmed so padded values still match (" 2 " vs RECORD_ALERT).
 *
 * Do **not** pass booleans. Many constants are "0"/"1"; in JS `"0" == false` and
 * `"1" == true`, so `isConstant('PAYPERIOD_NONE', false)` can be true by accident.
 * For real booleans, use `=== true` / `=== false` (or `!!value`) instead.
 *
 * @param key {String} - constant name
 * @param value {*} - code from API/DOM (string|number); not a boolean
 * @return {Boolean}
 */
function isConstant(key, value) {
  if (typeof value === 'string') {
    value = value.trim();
  }
  return getConstant(key) == value;
}

/**
 * Merge one or more constant groups (string list or array of group names).
 *
 * @param groups {String|Array} - e.g. 'ACCESS_TYPES' or ['ACCESS_TYPES','USER_STATUSES']
 * @return {Object} - merged flat map of constants from those groups
 */
function getGroupConstants(groups) {
  var list = [];
  if (typeof groups === 'string') {
    list = groups.split(',').map(function (g) { return g.trim(); }).filter(Boolean);
  } else if (Array.isArray(groups)) {
    list = groups;
  } else {
    throw new Error('getGroupConstants: groups must be a string list or array');
  }

  if (typeof CONST_GROUPS === 'undefined') {
    throw new Error('CONST_GROUPS is not defined');
  }

  var merged = {};
  for (var i = 0; i < list.length; i++) {
    var name = list[i];
    if (typeof CONST_GROUPS[name] === 'undefined') {
      throw new Error('Unknown constant group: ' + name);
    }
    var group = CONST_GROUPS[name];
    for (var k in group) {
      if (Object.prototype.hasOwnProperty.call(group, k)) {
        merged[k] = group[k];
      }
    }
  }
  return merged;
}
